import { useTranslations } from 'next-intl';

import { Button } from '@commons/components/Button';
import Card from '@commons/components/Card';
import DrupalImage from '@commons/components/Image/Drupal';
import TopoPatternImage from '@commons/components/Image/TopoPattern';
import Text from '@commons/components/Text';
import Flex from '@commons/containers/Flex';
import { Link } from '@commons/i18n/navigation';
import { CARD_DISPLAY_IMAGE_SIZES } from '@commons/pagebuilder/nodes/images';

import type { PageNodeProps } from '.';

/**
 * Page node component for the Card display type.
 */

const PageNodeCard = ({ image, title, summary, alias }: PageNodeProps) => {
  const t = useTranslations('commons');

  const renderedImage = image ? (
    <DrupalImage {...image} sizes={CARD_DISPLAY_IMAGE_SIZES} />
  ) : (
    <TopoPatternImage alt={title} sizes={CARD_DISPLAY_IMAGE_SIZES} />
  );

  return (
    <Link href={alias}>
      <Card>
        <Flex gap="xs" width={12} direction="column">
          <Card.Overlay>{renderedImage}</Card.Overlay>
          <Card.Title>{title}</Card.Title>
          {summary && <Text marginBottom="none">{summary}</Text>}
        </Flex>
        <Button variant="primary">{t('learnMore')}</Button>
      </Card>
    </Link>
  );
};

export default PageNodeCard;
